import { MaterialScoreDetails } from '@/services/score/material';
import { unitConversionService as unitService } from '@/services/unit-conversion.service';
import { FormaExpandedTooltip } from '@/components/UI/FormaExpandedTooltip/FormaExpandedTooltip';
import styles from './styles.module.scss';

type MaterialSection = keyof MaterialScoreDetails['breakdown'];

interface MaterialBreakdownProps {
	id: string;
	scoreData: MaterialScoreDetails;
}

export const MaterialBreakdown = ({ id, scoreData }: MaterialBreakdownProps) => {
	const sections: MaterialSection[] = ['wall', 'floor', 'ceiling'];

	return (
		<FormaExpandedTooltip
			loadingduration={500}
			position="left"
			text="Material Breakdown"
			targetId={id}
		>
			<div className={styles.scoreSummary}>
				<div className={styles.summaryTitle}>
					<strong>Score: {scoreData.score.toFixed(2)}</strong>
					<span>
						Total:{' '}
						{unitService.formatWithPreferredUnit(
							scoreData.totalSurfaceArea,
							'area',
							'm2'
						)}
					</span>
				</div>

				<div className={styles.simpleRecommendation}>{scoreData.recommendation}</div>

				<div className={styles.simpleTable}>
					{sections.map((section) => {
						const value = scoreData.breakdown[section];
						const color =
							value.bioScore < 4
								? '#ef4444'
								: value.bioScore < 7
									? '#f59e0b'
									: '#10b981';

						return (
							<div key={section} className={styles.tableRow}>
								<div className={styles.rowInfo}>
									<span className={styles.rowLabel}>{section.toUpperCase()}</span>
									<span className={styles.rowMeta}>
										{unitService.formatWithPreferredUnit(
											value.area,
											'area',
											'm2'
										)}
									</span>
								</div>
								<div className={styles.rowBarWrapper}>
									<div className={styles.simpleBarBg}>
										<div
											className={styles.simpleBarFill}
											style={{
												width: `${value.bioScore * 10}%`,
												backgroundColor: color,
											}}
										/>
									</div>
									<span className={styles.rowScore}>{value.bioScore}</span>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</FormaExpandedTooltip>
	);
};
